/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candid_Plain_Spider_EnjoyInputs */

const fr_candid_plain_spider_enjoy = /** @type {(inputs: Candid_Plain_Spider_EnjoyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer le mot de passe`)
};

/**

* @param {Candid_Plain_Spider_EnjoyInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const candid_plain_spider_enjoy = /** @type {((inputs?: Candid_Plain_Spider_EnjoyInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candid_Plain_Spider_EnjoyInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_candid_plain_spider_enjoy(inputs)
});